import { format } from 'date-fns';

const dateFieldLabels = {
  'createdAt': 'Criado em',
  'lastSale': 'Última venda',
  'birthDate': 'Data de nascimento'
};

export const formatFilterDescription = (filter) => {
  const fieldLabel = dateFieldLabels[filter.field] || filter.field;
  
  if (filter.type === 'specific_date' && filter.startDate) {
    const startDate = format(new Date(filter.startDate), 'dd/MM/yyyy');
    return `${fieldLabel}: ${startDate}`;
  } else if (filter.type === 'specific_month' && filter.month) {
    const months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
    const monthLabel = months[filter.month - 1];
    return filter.year ? `${fieldLabel}: ${monthLabel}/${filter.year}` : `${fieldLabel}: ${monthLabel} (todos os anos)`;
  } else if (filter.type === 'specific_year') {
    return `${fieldLabel}: ${filter.year}`;
  } else if (filter.startDate && filter.endDate) {
    const startDate = format(new Date(filter.startDate), 'dd/MM/yyyy');
    const endDate = format(new Date(filter.endDate), 'dd/MM/yyyy');
    return `${fieldLabel}: ${startDate} - ${endDate}`;
  } else {
    return `${fieldLabel}: filtro aplicado`;
  }
}; 